import { IMobileMenu } from '~/interfaces/menus/mobile-menu';
import categoryApi from '~/api/category';

const dataMobileMenu: IMobileMenu = [
  {
    type: 'link',
    title: 'Shop',
    url: '/shop/catalog',
    children: [],
  },

  {
    type: 'link',
    title: 'Catalogues',
    url: '/catalogues',
  },

  {
    type: 'link',
    title: 'Company',
    url: '/site/about-us',
    children: [
      { type: 'link', title: 'About Us', url: '/site/about-us' },
      {
        type: 'button',
        title: 'Contact Us',
        children: [
          { type: 'link', title: 'Enquiry', url: '/site/contact-us' },
          { type: 'link', title: 'Feedback', url: '/site/feedback' },
        ],
      },
      { type: 'link', title: 'Terms & Conditions', url: '/site/terms' },
    ],
  },
];

let menu: any = dataMobileMenu[0].children;

const loadCategories = async () => {
  const { data }: any = await categoryApi.list({
    'page[size]': 1000,
    status: 'O',
  });

  const url = (data: any) => {
    return `/shop/catalog/${data.id}`;
  };

  if (data) {
    data.forEach((e: any) => {
      menu.push({ type: 'link', title: e.name, url: `/shop/catalog/${e.id}` });
    });
  }
};

loadCategories();

export default dataMobileMenu;
